module.exports = __webpack_public_path__ + "static/dinamarie-8ac095010a9226faef628296d9a0fbc6.jpg";